import { render, staticRenderFns } from "./TourVoucherTaxi.vue?vue&type=template&id=97603878&scoped=true"
import script from "./TourVoucherTaxi.vue?vue&type=script&lang=js"
export * from "./TourVoucherTaxi.vue?vue&type=script&lang=js"
import style0 from "./TourVoucherTaxi.vue?vue&type=style&index=0&id=97603878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97603878",
  null
  
)

export default component.exports